import angular from 'angular'
import baseTemplate from 'views/common/template.html'
import addValTaxDeclaration from './addValTaxDeclaration'
import baseSetting from './baseSetting'
import incomeTax from './incomeTax'
import personlIncomeTax from './personalIncomeTax'
import vatDeclarationSurcharges from './vatDeclarationSurcharges'
import stampDuty from './stampDuty'
import corporateIncomeTax from './corporateIncomeTax'
import addValTaxSmallScale from './addValTaxSmallScale'
import declareASummary from './declareASummary'

export default angular
  .module('declaration', [
    addValTaxDeclaration,
    baseSetting,
    incomeTax,
    personlIncomeTax,
    vatDeclarationSurcharges,
    stampDuty,
    corporateIncomeTax,
    addValTaxSmallScale,
    declareASummary
  ])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      $stateProvider.state('declaration', {
        abstract: true,
        url: '/declaration',
        template: baseTemplate,
      })
    },
  ]).name



// WEBPACK FOOTER //
// ./src/app/declaration/index.js